import createDebug from "debug";

export const debug = createDebug("mud:network");
